import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Error.css";

import { useTranslation } from "../../i18n/TranslationContext";
import Header from "../../layouts/Header";

import errorSvgDark from "../../assets/images/404-dark.svg";
import errorSvgLight from "../../assets/images/404-light.svg";

export default function ErrorPage() {
  const navigate = useNavigate();
  const { t, lang, toggleLang } = useTranslation();
  const isAr = lang === "ar";

  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "dark");
  const [soonOpen, setSoonOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("theme", theme);
    document.body.classList.remove("theme-light", "theme-dark");
    document.body.classList.add(`theme-${theme}`);
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  const scrollToId = (id) => {
    navigate("/");
    window.clearTimeout(scrollToId._t);
    scrollToId._t = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 220);
  };

  const handleDownloadApp = () => {
    setSoonOpen(true);
    window.clearTimeout(handleDownloadApp._t);
    handleDownloadApp._t = window.setTimeout(() => setSoonOpen(false), 1600);
  };

  const errorSvg = theme === "light" ? errorSvgLight : errorSvgDark;

  return (
<div className={`aq-home aq-error-page theme-${theme}`} dir={isAr ? "rtl" : "ltr"} lang={lang}>

      <Header
        theme={theme}
        lang={lang}
        t={t}
        onToggleTheme={toggleTheme}
        onToggleLang={toggleLang}
        onDownload={handleDownloadApp}
        onScroll={scrollToId}
      />

      <main className="aq-error">
        <div className="aq-error-shell">
          <div className="aq-error-card">
            <img className="aq-error-illustration" src={errorSvg} alt="404" draggable="false" />

            <div className="aq-error-badge">{isAr ? "خطأ 404" : "404 Error"}</div>

            <h1 className="aq-error-title">{isAr ? "الصفحة غير موجودة" : "Page not found"}</h1>

            <p className="aq-error-desc">
              {isAr
                ? "ممكن يكون الرابط اتغير أو الصفحة اتحذفت. جرّب ترجع للرئيسية أو تتأكد من الرابط."
                : "The link may be broken or the page may have been moved. Go back home or double-check the URL."}
            </p>

            <div className="aq-error-actions">
              <button className="aq-btn aq-btn-solid" type="button" onClick={() => navigate("/")}>
                {isAr ? "الرجوع للرئيسية" : "Back to Home"}
              </button>

              <button className="aq-btn aq-btn-ghost" type="button" onClick={() => navigate(-1)}>
                {isAr ? "رجوع" : "Go Back"}
              </button>
            </div>

            {soonOpen ? <div className="aq-error-mini">{isAr ? "قريباً..." : "Coming soon..."}</div> : null}
          </div>
        </div>
      </main>
    </div>
  );
}
